import ReloadButton from 'CMFW/button/ReloadButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import { LoadingItem } from 'CMFW/layout/Loading';
import { ContainerLeft, ContainerLeftFooter, ContainerRight, ModuleContainer } from 'components/common/styles';
import { Split } from 'components/Split';
import { useForceRender } from 'hooks/useForceRender';
import { ConceptLinkerAiLinkerModel } from 'models/ConceptLinkerAiLinkerModel';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import ConceptLinkerAiLinkerDetails from '../components/ConceptLinkerAiLinkerDetails';
import ConceptLinkerAiLinkerCreate from '../components/ConceptLinkerAiLinkerCreate';
import { Button } from '@material-ui/core';
import { conceptValidatorStatusRenderer } from 'CMFW/grid/cellRenderers/conceptValidatorStatus';
import { IFields } from 'CMFW/grid/fields';

export type IProps = {
  courseId: number;
};

const ConceptLinkerAiLinker: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();
  const [showCreate, setShowCreate] = useState(false);

  const aiLinkerModel = useMemo(
    () => new ConceptLinkerAiLinkerModel({ render: forceRender, courseId: props.courseId }),
    [forceRender, props.courseId],
  );

  const cellRenderers = useMemo(
    () => ({
      [IFields.conceptValidatorStatus]: conceptValidatorStatusRenderer,
    }),
    [],
  );

  const handleNewClick = () => {
    setShowCreate(true);
  };

  const handleCreateClose = () => {
    setShowCreate(false);
  };

  const handleCreateSuccess = async (jobId: number) => {
    setShowCreate(false);
    await aiLinkerModel.loadItemEdit(jobId);
  };

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={aiLinkerModel}>
        <Split widthLeft={432}>
          <ContainerLeft>
            <Grid cellRenderers={cellRenderers} />
            <ContainerLeftFooter>
              <ReloadButton />
              <Button variant="outlined" onClick={handleNewClick} size="small">
                new
              </Button>
            </ContainerLeftFooter>
          </ContainerLeft>
          <ContainerRight>
            {showCreate ? (
              <ConceptLinkerAiLinkerCreate
                model={aiLinkerModel}
                courseId={props.courseId}
                onClose={handleCreateClose}
                onSuccess={handleCreateSuccess}
              />
            ) : aiLinkerModel.itemId ? (
              <ConceptLinkerAiLinkerDetails courseId={props.courseId} />
            ) : (
              <EmptyState>
                <EmptyStateText>Select a job from the list or create a new one</EmptyStateText>
              </EmptyState>
            )}
            <LoadingItem />
          </ContainerRight>
        </Split>
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

export default ConceptLinkerAiLinker;

const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #666;
`;

const EmptyStateText = styled.div`
  text-align: center;
  font-size: 16px;
`;
